/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  ChangeRequestStatusDto,
  GetAllChangeRequestStatusesParams,
  IReadOnlyListOfChangeRequestStatusDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all changerequeststatus enumeration values, with an optional filter.
 */
export const getAllChangeRequestStatuses = (
    params?: GetAllChangeRequestStatusesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfChangeRequestStatusDto>>,) => {
      return customInstance<IReadOnlyListOfChangeRequestStatusDto>(
      {url: `/changerequest/change-request-statuses`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the ChangeRequestStatus identified by the route id.
 */
export const getChangeRequestStatusById = (
    id: number,
 options?: SecondParameter<typeof customInstance<ChangeRequestStatusDto>>,) => {
      return customInstance<ChangeRequestStatusDto>(
      {url: `/changerequest/change-request-statuses/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllChangeRequestStatusesResult = NonNullable<Awaited<ReturnType<typeof getAllChangeRequestStatuses>>>
export type GetChangeRequestStatusByIdResult = NonNullable<Awaited<ReturnType<typeof getChangeRequestStatusById>>>
